import React from "react";
import '../../scss/components/Navbar.scss';
import LogoutLink from '../../components/Nav/LogoutLink.tsx';
import { NavLink } from "react-router";
import UserIcon from "../../img/inline/UserIcon.tsx";
import DashboardIcon from "../../img/inline/DashboardIcon.tsx";
import CalendarIcon from "../../img/inline/CalendarIcon.tsx";
import SettingsIcon from "../../img/inline/SettingsIcon.tsx";
import DownloadsIcon from "../../img/inline/DownloadsIcon.tsx";
import ShieldCheckIcon from "../../img/inline/ShieldCheckIcon.tsx";
import { useProfileContext } from "../../features/auth/hooks/use-profile-context.ts";

const Navbar = () => {
    const { needsInitialReview } = useProfileContext();

    return (
        <nav className="navbar-left">
            <NavLink to={`/`} end><DashboardIcon />Dashboard</NavLink>
            <NavLink to={`/profile`} end><UserIcon />Profilinformationen</NavLink>
            <NavLink to={`/auftraege`} end><ShieldCheckIcon />Zentralprüfung</NavLink>
            <NavLink to={`/dokumentencenter`} end><DownloadsIcon />Dokumentencenter</NavLink>
            { !needsInitialReview && (
                <NavLink to={process.env.REACT_APP_FPSB_PORTAL_CPD_FEED_URL} target="_blank"><CalendarIcon />CPD-Veranstaltungsliste</NavLink>
            ) }
            <NavLink to={`/profile/settings`} end><SettingsIcon />Kontoeinstellungen</NavLink>
            <hr></hr>
            <LogoutLink icon></LogoutLink>
        </nav>
    )
}

export default Navbar;
